module.exports = __webpack_public_path__ + "img/tjx_15.b7351eb8.png";